import logger from './logger';

// Gemeinsame Konstante für die Standard-Padding-Länge, wenn kein explizites Padding angegeben ist
const DEFAULT_PADDING = 3; 

// Funktion zum Generieren einer Beispiel-Rechnungsnummer
export const generateInvoiceNumber = (format: string, currentNumber: number, date: Date): string => {
  let result = format
    .replace(/yyyy/g, date.getFullYear().toString())
    .replace(/yy/g, date.getFullYear().toString().substr(2))
    .replace(/mm/g, (date.getMonth() + 1).toString().padStart(2, '0'))
    .replace(/MM/g, (date.getMonth() + 1).toString().padStart(2, '0'));
  
  const numberMatch = result.match(/\{number(?::(\d+))?\}/);
  if (numberMatch) {
    const padding = numberMatch[1] ? parseInt(numberMatch[1]) : DEFAULT_PADDING;
    const formattedNumber = currentNumber.toString().padStart(padding, '0');
    result = result.replace(numberMatch[0], formattedNumber);
  } else {
    // Wenn kein Platzhalter gefunden, Nummer mit Standard-Padding anhängen
    result += currentNumber.toString().padStart(DEFAULT_PADDING, '0');
  }
  return result;
};

// Funktion zum Generieren einer Beispiel-Angebotsnummer (sollte exakt wie Rechnungsnummern funktionieren)
export const generateOfferNumber = (format: string, currentNumber: number, date: Date): string => {

  
  // Datum-Ersetzungen durchführen (genau wie bei generateInvoiceNumber)
  let result = format
    .replace(/yyyy/g, date.getFullYear().toString())
    .replace(/yy/g, date.getFullYear().toString().substr(2))
    .replace(/mm/g, (date.getMonth() + 1).toString().padStart(2, '0'))
    .replace(/MM/g, (date.getMonth() + 1).toString().padStart(2, '0'));
  
  // Nummer-Platzhalter ersetzen (genau wie bei generateInvoiceNumber)
  const numberMatch = result.match(/\{number(?::(\d+))?\}/);
  if (numberMatch) {
    // Padding aus dem Format extrahieren oder Standardwert verwenden
    const padding = numberMatch[1] ? parseInt(numberMatch[1]) : DEFAULT_PADDING;
    
    // Entferne Math.max(1, ...), um die übergebene Nummer (Start oder Current) direkt zu verwenden
    // const numberToUse = Math.max(1, Math.floor(currentNumber)); 
    const numberToUse = currentNumber; // Direkt die übergebene Nummer verwenden
    
    // Nummer mit entsprechendem Padding formatieren
    const formattedNumber = numberToUse.toString().padStart(padding, '0');
    
    // Ersetze den Platzhalter mit der formatierten Nummer
    result = result.replace(numberMatch[0], formattedNumber);
    
    logger.debug({originalNumber: currentNumber, usedNumber: numberToUse, formattedNumber}, "Number formatting details");
  } else {
    // Wenn kein Platzhalter gefunden wurde, füge die Nummer standardmäßig am Ende hinzu
    // (genau wie bei generateInvoiceNumber)
    // Entferne Math.max(1, ...)
    // const numberToUse = Math.max(1, Math.floor(currentNumber));
    const numberToUse = currentNumber; // Direkt die übergebene Nummer verwenden
    result += numberToUse.toString().padStart(DEFAULT_PADDING, '0');

  }
  

  return result;
}; 